<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="['animation-rotate', isCollapsed ? 'rotated' : '']"
  >
    <path
      d="M6 15.01L12 9.01001L18 15.01"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: 'CollapseIcon',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="postcss">
.animation-rotate {
  transition: 0.1s ease-in-out;
}
.rotated {
  transform: rotate(180deg);
}
</style>